import { useEffect } from "react";

import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrCard from "UI/FnrCard/FnrCard";
import FnrCheckNReveal from "UI/FnrCheckNReveal/FnrCheckNReveal";
import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";

import extendedFieldInputContainers from "../containers";

import IigHelp from "./IigHelp";

const { IconContainer } = extendedFieldInputContainers;

const IIG = () => {
  const [iigOn, setIig] = extendedFieldHooks.useIig();
  const [periodicIIGOn, setPeriodicIig] = extendedFieldHooks.usePeriodicIig();
  const [editPermission] = extendedFieldHooks.useEditPermissionId();
  const handleSetIig = () => {
    const newValue = !iigOn;
    setIig(newValue);
  };

  const handleSetPeriodicIig = () => {
    const newValue = !periodicIIGOn;
    setPeriodicIig(newValue);
  };

  useEffect(() => {
    if (!iigOn) setPeriodicIig(false);
  }, [iigOn, setPeriodicIig]);

  return (
    <FnrCard data-cy="ExtendedFields_IIG">
      <FnrHorizontalGap>
        <FnrCheckNReveal
          on={iigOn}
          toggleOn={handleSetIig}
          data-cy="IIG_CheckBox"
          addMargin
          disabled={editPermission > 1}
          revealedChildren={
            <FnrCheckbox
              on={periodicIIGOn}
              toggleOn={handleSetPeriodicIig}
              data-cy="IIG_PeriodicCheckBox"
              // just as a precaution, the user should not be allowed to interact with this in case it was visible for some unforseen reason.
              disabled={editPermission > 1}
            >
              <FnrTypography>
                Also, have Flocknote keep this field updated periodically?
              </FnrTypography>
            </FnrCheckbox>
          }
        >
          <FnrTypography>
            Have Flocknote ask members to fill in this field in their profile
            using <em>Intelligent Info Gathering</em>? <IigHelp />
          </FnrTypography>
        </FnrCheckNReveal>
        <IconContainer>
          <FnrIcon icon="fa-head-side-brain fad" />
        </IconContainer>
      </FnrHorizontalGap>
    </FnrCard>
  );
};

export default IIG;
